import React from 'react'
import cx from 'classnames'

import { Box } from 'components/layout/Box/Box'
import { List } from 'components/shared/List/List'
import { StepProgress } from 'components/shared/StepProgress/StepProgress'
import { StepButton } from './common/StepButton/StepButton'

import { ChevronLeftIcon, ChevronRightIcon } from 'components/shared/Icon/model'

import styles from './StepProgressGroup.module.scss'
import { useTabScrollIntoView } from 'hooks'

type Step = {
  key: string
  label?: string
  isActive?: boolean
  isDisabled?: boolean
  isDone?: boolean
  isEdited?: boolean
}

type StepProgressGroupProps = {
  activeStep?: string
  className?: string
  size?: string
  steps?: Step[]
  onNextStep?: () => void
  onPreviousStep?: () => void
  onStep?: (key: string) => void
  hasActions?: boolean
  isNextDisabled?: boolean
  isPreviousDisabled?: boolean
}

export const StepProgressGroup = ({
  activeStep,
  className,
  size,
  steps = [],
  onNextStep,
  onPreviousStep,
  onStep,
  hasActions = false,
  isNextDisabled,
  isPreviousDisabled,
}: StepProgressGroupProps) => {
  const ref = useTabScrollIntoView(activeStep)

  return (
    <Box align="center" className={cx(styles.group, className)}>
      {hasActions ? (
        <StepButton
          ariaLabel="previous step"
          className={styles.button}
          icon={ChevronLeftIcon}
          onClick={onPreviousStep}
          isDisabled={isPreviousDisabled}
        />
      ) : null}
      <List ariaLabel="progressGroup" className={styles.list} tagName="menu">
        {steps.map(({ key, label, isActive, isDisabled, isDone, isEdited }) => (
          <List.Item
            className={cx(styles.item, {
              [styles.size]: Boolean(size),
              [styles[size ?? '']]: Boolean(size),
            })}
            key={key}
          >
            <StepProgress
              onClick={() => onStep?.(key)}
              {...{
                label,
                ref,
                size,
                isActive,
                isDisabled,
                isDone,
                isEdited,
              }}
            />
          </List.Item>
        ))}
      </List>
      {hasActions ? (
        <StepButton
          ariaLabel="next step"
          className={styles.button}
          icon={ChevronRightIcon}
          onClick={onNextStep}
          isDisabled={isNextDisabled}
        />
      ) : null}
    </Box>
  )
}
